import { ELanguage, REQUIRED_COVER_LETTER } from '@/common'
import { IJobDetail } from '@/services/jobs/type'
import { convertDateTime } from '@microfrontends/react-components/components/Utils/time'

export function getPrettySalary(
    salaryRangeId?: number,
    salaryMin?: number,
    salaryMax?: number,
    isSalaryVisible?: boolean,
    langCode?: ELanguage
) {
    let prettySalary = ''

    if (isSalaryVisible && salaryRangeId === 0) {
        if (!salaryMin && salaryMax) {
            prettySalary =
                langCode === ELanguage.EN
                    ? 'Up to $' + salaryMax
                    : 'Tới $' + salaryMax
        } else if (salaryMin && !salaryMax) {
            prettySalary =
                langCode === ELanguage.EN
                    ? 'From $' + salaryMin
                    : 'Từ $' + salaryMin
        } else if (salaryMin && salaryMax) {
            prettySalary = '$' + salaryMin + ' - $' + salaryMax
        } else {
            prettySalary =
                langCode === ELanguage.EN ? 'Negotiable' : 'Thương lượng'
        }
    } else {
        prettySalary = langCode === ELanguage.EN ? 'Negotiable' : 'Thương lượng'
    }

    return prettySalary
}

export function diffDateExpired(dateExpired: string, langCode: ELanguage) {
    const now = new Date()
    const dateExpiredDate = new Date(dateExpired)
    //  Get Time Difference Between Two DateTimes
    const diffInMilliseconds = Math.abs(
        Math.floor((now.getTime() - dateExpiredDate.getTime()) / 1000)
    )
    // Approximate time units in milliseconds
    const monthInMilliseconds = 30 * 24 * 60 * 60
    const dayInMilliseconds = 24 * 60 * 60
    const hourInMilliseconds = 60 * 60
    const minuteInMilliseconds = 60
    const isEn = langCode === ELanguage.EN
    let expired = isEn ? 'Expires in ' : 'Hết hạn trong '

    if (diffInMilliseconds > monthInMilliseconds) {
        const months = Math.floor(diffInMilliseconds / monthInMilliseconds)
        expired +=
            months + (isEn ? (months > 1 ? ' months' : ' month') : ' tháng')
    } else if (diffInMilliseconds > dayInMilliseconds) {
        const days = Math.floor(diffInMilliseconds / dayInMilliseconds)
        expired += days + (isEn ? ' days' : ' ngày')
    } else if (diffInMilliseconds > hourInMilliseconds) {
        const hours = Math.floor(diffInMilliseconds / hourInMilliseconds)
        expired += hours + (isEn ? ' hours' : ' giờ')
    } else if (diffInMilliseconds > minuteInMilliseconds) {
        const minutes = Math.floor(diffInMilliseconds / minuteInMilliseconds)
        expired += minutes + (isEn ? ' minutes' : ' phút')
    } else {
        expired = isEn ? 'Posted few seconds ago' : 'Đăng vài giây trước'
    }

    // Handle expired case
    if (now > dateExpiredDate) {
        expired = isEn ? 'Expired' : 'Đã hết hạn'
    }

    return expired
}

export function mapTrackingJobProperties(jobDetail: Partial<IJobDetail>) {
    const SERVICE_CODE_REFRESH_JOB_CLP_REWARD = 'RJF'
    const checkIsNewData = (item: Partial<IJobDetail>) => {
        if (
            item.onlineServiceCode ===
            SERVICE_CODE_REFRESH_JOB_CLP_REWARD
        ) {
            return false
        }

        return (
            convertDateTime(new Date(item.onlineOn || ''), 7) ===
            convertDateTime(Date.now(), 7)
        )
    }

    const shouldMakeJobPriority: boolean = jobDetail?.priorityOrder !== undefined && (Date.parse(jobDetail?.priorityOrder) / 1000) > 0

    const properties: any = {
        jobId: Number(jobDetail?.jobId),
        jobTitle: jobDetail?.jobTitle || '',
        views: Number(jobDetail?.numOfViews),
        prettySalary:
            jobDetail?.prettySalary === 'Thương lượng'
                ? 'Negotiable'
                : jobDetail?.prettySalary || '',
        createdOn: jobDetail?.createdOn || '',
        workingLocationCityId: [
            ...new Set(
                (jobDetail?.workingLocations || []).map(
                    (item) => item.cityId
                )
            )
        ],
        jobIndustryId: (jobDetail?.industriesV3 || []).map(
            (item) => item.industryV3Id
        ),
        jobFunctionId: (jobDetail?.jobFunction?.children || []).map(
            (item) => item.id
        ),
        jobGroupFunctionId: jobDetail?.jobFunction?.parentId || '',
        jobLevelId: Number(jobDetail?.jobLevelId),
        typeWorkingId: jobDetail?.typeWorkingId,
        skillTag: (jobDetail?.skills || [])
            .map((item) => item.skillName)
            .join(', '),
        isCoverLetterRequired: jobDetail?.requiredCoverLetter
            ? jobDetail?.requiredCoverLetter === REQUIRED_COVER_LETTER
            : false,
        isAnonymous: !!jobDetail?.isAnonymous,
        isPremium: !!jobDetail?.isPremiumJob,
        isHeadhunt: !!jobDetail?.isHeadHuntJob,
        isTopmanagement: !!jobDetail?.isTopManagementJob,
        isUrgent: !!jobDetail?.isUrgentJob,
        isUrgentM: !!jobDetail?.isUrgentJobM,
        isAdr: !!jobDetail?.isAdrLiteJob,
        isPriority: shouldMakeJobPriority,
        isPriorityM: shouldMakeJobPriority && (jobDetail?.isTopPriorityM ?? false),
        isNew: checkIsNewData(jobDetail),
        isBoldandred: jobDetail?.isBoldAndRed,
        isBoldandredM: jobDetail?.isBoldAndRedM,
        companyId: Number(jobDetail?.companyId)
    }
    if (jobDetail?.jobInvitation && jobDetail?.jobInvitation?.jobInvitationId > 0) {
        properties.invitationId = jobDetail?.jobInvitation?.jobInvitationId
    }

    return properties
}
